// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__ByO7a","Cards-wrapper":"Cards_Cards-wrapper__VB5jw","card":"Cards_card__uHr7G","icon-wrapper":"Cards_icon-wrapper__iVEtN"};